import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function MondayConnectForm({ onSubmit, guideMode }) {
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);
  const formInitialValues = {
    api_token: "",
  };
  const formCheckoutSchema = yup.object().shape({
    api_token: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                type={showSecret ? "text" : "password"}
                name="api_token"
                autoComplete="off"
                label="API Key"
                value={values.api_token}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.api_token && !!errors.api_token}
                helperText={touched.api_token && errors.api_token}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
